import React, { useEffect } from 'react';
import styles from './send-phone-otp-step.module.scss';
import { autoId } from '@workday/upc-common';
import { ID_RESET_PASSWORD_UNABLE_TO_ACCESS_MOBILE_SMS, ID_USER_CONSENT_BUTTON } from '../../../autoIds';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import { Contact, useResetPasswordUserConsentForPhoneOtpMutation } from '../../../slices/auth-api.slice';
import { Flex } from '@workday/canvas-kit-react';
import { TertiaryButtonLink } from '../tertiary-button-link';
import { AlternativeContactLink } from '../alternative-contact-link';
import { emailContactLinkProps } from './emailContactLinkProps';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ERROR_PATH } from '../../../react-router-paths';
import { UNAUTH_FLOW } from '../../../shared/error-page/error-page';

interface SendPhoneOtpStepProps {
    contacts: Array<Contact>;
    onNext: () => void;
}

export function SendPhoneOtpStep({ onNext, contacts }: SendPhoneOtpStepProps) {
    const history = useHistory();
    const [resetPasswordUserConsentForPhoneOtp, { isSuccess, isError }] =
        useResetPasswordUserConsentForPhoneOtpMutation();

    const { t } = useTranslation('auth');

    const phoneContact = contacts.find(contact => contact.contactType === 'phone');

    useEffect(() => {
        if (isSuccess) {
            onNext();
        }
        if (isError) {
            history.replace({
                pathname: ERROR_PATH,
                state: {
                    context: UNAUTH_FLOW
                }
            });
        }
    }, [history, onNext, isSuccess, isError]);

    function onSubmit(e) {
        e.preventDefault();
        const payload = {
            contactId: phoneContact?.contactId,
            userConsent: true
        };
        resetPasswordUserConsentForPhoneOtp(payload);
    }

    return (
        <form className={styles.userConsent} onSubmit={onSubmit}>
            <h1 className={styles.title}>{t('SendPhoneOtpStep.title')}</h1>
            <p className={styles.description}>{t('SendPhoneOtpStep.description')}</p>
            <p className={styles.email}>{phoneContact?.displayName}</p>
            <PrimaryButton
                {...autoId(ID_USER_CONSENT_BUTTON)}
                size='large'
                type='submit'
                grow={true}
                marginBottom='1rem'>
                {t('SendPhoneOtpStep.submitButton')}
            </PrimaryButton>
            <Flex flexDirection='column'>
                <AlternativeContactLink {...emailContactLinkProps} />
                <TertiaryButtonLink
                    to={ERROR_PATH}
                    context={UNAUTH_FLOW}
                    {...autoId(ID_RESET_PASSWORD_UNABLE_TO_ACCESS_MOBILE_SMS)}>
                    {t('SendPhoneOtpStep.unableToAccessMobile')}
                </TertiaryButtonLink>
            </Flex>
        </form>
    );
}
